import React from 'react';
import Bootstrap from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import AdelaideRivieraHotelStay from '../../pactum-server/stubs/stayContentFactory';

const StayAmenities: React.FC = () => {
  const args = {
    stay: AdelaideRivieraHotelStay({}),
    fullWidth: true,
  };

  return (
    <Bootstrap>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'StayAmenities' }} {...args} />
    </Bootstrap>
  );
};

export default StayAmenities;
